import { useState, useMemo, useRef, useEffect } from "react"
import { useRequest } from "ahooks";
import { Card, Button, Modal, Form, Select, Input, message } from "antd";
import { EditForm } from "../../../components/editForm";
import { Table, DEFAULT_PAGE_DATA } from "../../../components/table";
import { DEFAULT_QUERY_DATA, generateQueryFormConfig, generateTableColumns } from "./config";
import { AmountServer } from "../../../server";
import { Operation } from "./operation";
import dayjs from "dayjs";

const server = AmountServer.Recharge

export const Recharge = () => {
    const operationRef: any = useRef();

    const [loading, setLoading] = useState<boolean>(false);
    const [showQueryAccount, setShowQueryAccount] = useState<boolean>(false);
    const [queryData, setQueryData] = useState<any>({ ...DEFAULT_QUERY_DATA });
    const [tableData, setTableData] = useState<any[]>([]);
    const [networkTypeOptions, setNetworkTypeOptions] = useState<any>([]);
    const [pageData, setPageData] = useState<any>({ ...DEFAULT_PAGE_DATA });
    const [form] = Form.useForm();

    //获取表格数据
    const { run, refresh } = useRequest(server.list, {
        defaultParams: [{ ...pageData }],
        onBefore: () => setLoading(true),
        onFinally: () => setLoading(false),
        onError: () => {
            setTableData([]);
            setPageData({ ...pageData, Total: 0 });
        },
        onSuccess: (res: any) => {
            const { Total, List, Page, PageSize } = res;
            setTableData(List);
            setPageData({ Page, PageSize, Total });
        }
    });
    useEffect(()=> {
        getNetworkTypes()
    }, [])
    const getQueryFormConfig = useMemo(() => {
        return generateQueryFormConfig({networkTypeOptions});
    }, [networkTypeOptions]);

    const getTableColumns = useMemo(() => {
        return generateTableColumns({ operationRef, loading, setLoading, refresh });
    }, [operationRef, loading, setLoading, refresh]);

    const formatQueryDate = () => {
        let { AuditAtStart, AuditAtEnd, CreatedAtStart, CreatedAtEnd, ...otherData } = queryData;
        const format = 'YYYY-MM-DD HH:mm:ss'
        AuditAtStart = AuditAtStart ? dayjs(AuditAtStart).startOf('day').format(format) : null;
        AuditAtEnd = AuditAtEnd ? dayjs(AuditAtEnd).endOf('day').format(format) : null;
        CreatedAtStart = CreatedAtStart ? dayjs(CreatedAtStart).startOf('day').format(format) : null;
        CreatedAtEnd = CreatedAtEnd ? dayjs(CreatedAtEnd).endOf('day').format(format) : null;
        return { ...otherData, AuditAtStart, AuditAtEnd, CreatedAtStart, CreatedAtEnd };
    };
    const getNetworkTypes = async () => {
        // 调用后端API
        const response = await server.networkType({});
        if (response) {
            const convertedArray = Object.entries(response).map(([value, label]) => ({
                id: Number(value), // 如果需要 value 是数字类型
                name: label
            }));
            console.log('convertedArray', convertedArray)
            setNetworkTypeOptions(convertedArray)
        }
    }
    const queryAccount = () => {
        setShowQueryAccount(true)
    }
    const handleQueryAccountCancel = () => {
        setShowQueryAccount(false)
        form.resetFields();
    }
    const handleSumbitQueryAccount = async (values: any) => {
        // 调用后端API
        const response = await server.queryAccountSumbit({
            Address: values.walletAddress,
            Email: values.email,
            Hash: values.tradeHash,
            NetworkId: values.networkId,
            Amount: values.amount
        });
        if (response) {
            message.success('提交成功');
            handleQueryAccountCancel();
            run({ ...pageData, ...formatQueryDate() });
        }
    }
    return (
        <div>
            <Card>
                <div className="flex space-between align-center ">
                    <EditForm
                        componentId="recharge-query-form"
                        loading={loading}
                        formAttrsProps={{
                            layout: 'inline',
                        }}
                        formData={queryData}
                        onDataChange={setQueryData}
                        formConfig={getQueryFormConfig}
                        onQuery={() => {
                            run({ ...DEFAULT_PAGE_DATA, ...formatQueryDate() });
                        }}
                        onReset={() => {
                            setQueryData({ ...DEFAULT_QUERY_DATA });
                            run({ ...DEFAULT_QUERY_DATA, ...DEFAULT_PAGE_DATA });
                        }}
                    />
                    <Button type="primary" onClick={queryAccount}>
                        查询入账
                    </Button>
                </div>
            </Card>
            <Card className="mt20">
                <Table
                    loading={loading}
                    dataSource={tableData}
                    columns={getTableColumns}
                    rowKey="Id"
                    scroll={{
                        x: 'max-content'
                    }}
                    page={pageData}
                    onPageChange={(Page: number, PageSize: number) => {
                        const currentPage = { ...pageData, Page, PageSize };
                        run({ ...currentPage, ...formatQueryDate() });
                    }}
                />
            </Card >
            <Operation ref={operationRef} onSuccess={refresh} />
            <Modal
                title="查询入账"
                visible={showQueryAccount}
                onCancel={handleQueryAccountCancel}
                onOk={() => form.submit()}
                okText="确认"
                cancelText="取消"
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleSumbitQueryAccount}
                    autoComplete="off"
                >
                    <Form.Item
                        label="网络类型"
                        name="networkId"
                        rules={[{ required: true, message: '请选择网络类型' }]}
                    >
                        <Select placeholder="请选择网络类型"
                        >
                            {networkTypeOptions.map((type: any) => (
                                <Select.Option key={type.id} value={type.id}>
                                    {type.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="交易hash"
                        name="tradeHash"
                        rules={[
                            { required: true, message: '请输入交易hash' },
                        ]}
                    >
                        <Input placeholder="请输入交易hash" />
                    </Form.Item>

                    <Form.Item
                        label="用户邮箱"
                        name="email"
                    >
                        <Input placeholder="请输入用户邮箱" />
                    </Form.Item>
                    <Form.Item
                        label="转出钱包地址"
                        name="walletAddress"
                        rules={[
                            { required: true, message: '请输入转出钱包地址' },
                        ]}
                    >
                        <Input placeholder="请输入转出钱包地址" />
                    </Form.Item>

                    <Form.Item
                        label="交易金额"
                        name="amount"
                    >
                        <Input type="number" min={0} placeholder="请输入交易金额" />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
}